enum OnePageGivingFormField {
  Amount = 'GivingPageDonation.Amount',
  IsAmountCustom = 'GivingPageDonation.IsAmountCustom',
  HasButtonSelected = 'GivingPageDonation.HasButtonSelected',
  RecaptchaResponse = 'RecaptchaResponse',
  EmbeddedPaymentPaymentMethodData = 'EmbeddedPayment.PaymentMethodData',
  EmbeddedPaymentAdditionalData = 'EmbeddedPayment.AdditionalData',
};

export default OnePageGivingFormField;